// Finance section tabs (CEO 2026-10-09): one row of real links so a refresh or
// a pasted URL lands on the right screen.
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";
import { focusRing } from "./shared";

const TABS = [
  { to: "/finance", label: "Overview", end: true },
  { to: "/finance/open-items", label: "Open items" },
  { to: "/finance/numbers", label: "Live numbers" },
  { to: "/finance/health", label: "Health & cash" },
  { to: "/finance/export", label: "Export" },
];

export function FinanceNav() {
  return (
    <nav aria-label="Finance" className="mt-6 flex gap-6 overflow-x-auto border-b border-rule">
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) =>
            cn("-mb-px whitespace-nowrap border-b-2 pb-2 text-label font-semibold", focusRing, isActive ? "border-ink text-ink" : "border-transparent text-ink-muted hover:text-ink")
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function FinanceHeader({ title, intro }: { title: string; intro: string }) {
  return (
    <header>
      <p className="text-meta text-ink-muted">Finance</p>
      <h1 className="text-[32px] font-semibold leading-[1.15] tracking-[-1px]">{title}</h1>
      <p className="mt-2 max-w-[68ch] text-body text-ink-muted">{intro}</p>
      <FinanceNav />
    </header>
  );
}
